<template>

  <div class="vehicle-filter-results-component">

    <div class="container">
      <div v-if="vehicles && adminPortalData && showShortlistedCars === false">
        <div class="row">
          <div class="col-lg-4 col-xl-3" v-for="(vehicle, index) in vehicles" :key="'vehicle-all-' + index">
            <shortlist-card
              :driverGradeId="formData.uri_params.DriverGradeID"
              :currentDriverGrade="currentDriverGrade"
              :currentProduct="currentProduct"
              :filterParams="formData.uri_params"
              :bodyParams="formData.body_params"
              :scheme="scheme"
              :session="session"
              :short-list-items="shortListItems"
              :shortlist="shortlist"
              :vehicle="vehicle"
              :adminPortalData="adminPortalData"
              :configuration="cardConfiguration"
              :driverGradesById="driverGradesById"
            />

          </div>
        </div>
        <div class="row">
          <div class="col-6 col-xl-4 offset-xl-4 text-center"></div>
          <div class="col-6 col-xl-4 text-end">
            <paginator
              :totalRecords="totalRecords"
              :startRecord="startRecord"
              :endRecord="endRecord"
              :perPage="perPage"
              @gotoPage="paginatorUpdated"
            />
          </div>
        </div>
      </div>

      <div class="row" v-if="vehicles && showShortlistedCars && adminPortalData">
        <template v-for="(vehicle, index) in vehicles" :key="'vehicle-shortlist-' + index">
          <div class="col-lg-4 col-xl-3" v-if="shortListItems[vehicle.derivativeID] !== 0">
            <shortlist-card
              :driverGradeId="formData.uri_params.DriverGradeID"
              :currentDriverGrade="currentDriverGrade"
              :currentProduct="currentProduct"
              :filterParams="formData.uri_params"
              :bodyParams="formData.body_params"
              :scheme="scheme"
              :session="session"
              :short-list-items="shortListItems"
              :shortlist="shortlist"
              :vehicle="vehicle"
              :adminPortalData="adminPortalData"
              :configuration="cardConfiguration"
              :driverGradesById="driverGradesById"
            />
          </div>
        </template>
      </div>
      <div class="row" v-if="!loading && (!vehicles || vehicles.length === 0)">
        <div class="col-12">
          <div class="mb-5 text-center">
            <h4>No vehicles found</h4>
            <p>Please refine your filters or
              <button class="button--unstyled" @click.prevent="resetFilters()">click here</button>
              to reset your search
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="selected-vehicle-standard-specification"
      :class="{ 'selected-vehicle-standard-specification--show' : selectedVehicle }">

      <div v-if="selectedVehicle">

        <!-- Header -->
        <div class="row">
          <div class="col-10 text-start">
            <div class="vehicle-make-model">
              <h3>{{ selectedVehicle.vehicle.manufacturerName }} <span>{{ selectedVehicle.vehicle.rangeName }}</span>
              </h3>
              <h4>{{ selectedVehicle.vehicle.derivativeName }}</h4>
            </div>
          </div>
          <div class="col-2 text-end">
            <button @click="hideStandardSpecification" class="close"><i class="icon-cross"></i></button>
          </div>
        </div>

        <!-- Slider -->
        <div class="row">
          <div class="col-12">

            <!-- Main -->
            <slick
              ref="slick"
              :options="slickMain"
              class="slickMain"
              @afterChange="handleAfterChange"
              @beforeChange="handleBeforeChange"
              @breakpoint="handleBreakpoint"
              @destroy="handleDestroy"
              @edge="handleEdge"
              @init="handleInit"
              @reInit="handleReInit"
              @setPosition="handleSetPosition"
              @swipe="handleSwipe"
              @lazyLoaded="handleLazyLoaded"
              @lazyLoadError="handleLazeLoadError">
              <div>
                <vehicle-image :derivative="selectedVehicle.vehicle"/>
              </div>
            </slick>

            <!-- Thumbs -->
            <slick v-if="false"
              ref="slick"
              :options="slickThumbs"
              class="slickThumbs"
              @afterChange="handleAfterChange"
              @beforeChange="handleBeforeChange"
              @breakpoint="handleBreakpoint"
              @destroy="handleDestroy"
              @edge="handleEdge"
              @init="handleInit"
              @reInit="handleReInit"
              @setPosition="handleSetPosition"
              @swipe="handleSwipe"
              @lazyLoaded="handleLazyLoaded"
              @lazyLoadError="handleLazeLoadError">
              <div><img
                :src="`/api/vehicle-image/{selectedVehicle.vehicle.derivativeID}`"
                :alt="`${selectedVehicle.vehicle.manufacturerName} ${selectedVehicle.vehicle.modelName}`">
              </div>
              <div><img
                :src="`/api/vehicle-image/{selectedVehicle.vehicle.derivativeID}`"
                :alt="`${selectedVehicle.vehicle.manufacturerName} ${selectedVehicle.vehicle.modelName}`">
              </div>
              <div><img
                :src="`/api/vehicle-image/{selectedVehicle.vehicle.derivativeID}`"
                :alt="`${selectedVehicle.vehicle.manufacturerName} ${selectedVehicle.vehicle.modelName}`">
              </div>
              <div><img
                :src="`/api/vehicle-image/{selectedVehicle.vehicle.derivativeID}`"
                :alt="`${selectedVehicle.vehicle.manufacturerName} ${selectedVehicle.vehicle.modelName}`">
              </div>
              <div><img
                :src="`/api/vehicle-image/{selectedVehicle.vehicle.derivativeID}`"
                :alt="`${selectedVehicle.vehicle.manufacturerName} ${selectedVehicle.vehicle.modelName}`">
              </div>
              <div><img
                :src="`/api/vehicle-image/{selectedVehicle.vehicle.derivativeID}`"
                :alt="`${selectedVehicle.vehicle.manufacturerName} ${selectedVehicle.vehicle.modelName}`">
              </div>
            </slick>

          </div>
        </div>

        <!-- Accordion -->
        <div class="row" v-if="selectedVehicle.derivateInformation">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <h5>Standard Specification</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="accordion" id="accordion-parent">
                  <div v-for="(items, key, index) in selectedVehicle.derivateInformation" class="card">
                    <template v-if="selectedVehicle.derivateInformation">
                      <div class="card-header" :id="`heading-${index}`">
                        <h2 class="mb-0">
                          <button class="btn btn-link" type="button" data-bs-toggle="collapse"
                            :data-bs-target="`#collapse-${index}`" aria-expanded="false"
                            :aria-controls="`collapse-${index}`">
                            {{ key }}
                          </button>
                        </h2>
                      </div>
                      <div :id="`collapse-${index}`" class="collapse"
                        :aria-labelledby="`heading-${index}`" data-bs-parent="#accordion-parent">
                        <div class="card-body">
                          <ul>
                            <li v-for="item in items">{{ item }}</li>
                          </ul>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
import {EventBus} from '@/event-bus.js';
import Slick from 'vue-slick';
import Paginator from './paginator'
import ShortlistCard from "./shortlist/shortlist-card";
import VehicleImage from "./vehicle-details/vehicle-image";
import {useRoute} from 'vue-router'

export default {
  components: {
    VehicleImage,
    ShortlistCard,
    EventBus,
    Slick,
    Paginator,
  },

  props: [
    'adminPortalData',
    'currentProduct',
    'endRecord',
    'formData',
    'loadMoreBtnVisible',
    'perPage',
    'session',
    'scheme',
    'shortlist',
    'showShortlistedCars',
    'startRecord',
    'totalRecords',
    'vehicles',
    'loading',
    'driverGrades',
    'currentDriverGrade',
    'driverGradesById',
  ],

  data: () => {
    return {
      shortListItems: {},
      shortListItemCount: null,
      selectedVehicle: null,
      newShortList: {},
      slickMain: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
        speed: 750,
        asNavFor: '.slickThumbs',
        arrows: false,
      },

      slickThumbs: {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
        speed: 750,
        asNavFor: '.slickMain',
        focusOnSelect: true,
        arrows: false
      },

      tooltip: true

    }
  },

  setup() {
    const route = useRoute()
    return { route }
  },

  computed: {
    cardConfiguration() {
      if (this.route.params.scheme === 'bch') {
        return {
          showContribution: this.productData.display_settings_show_monthly_contribution ? this.productData.display_settings_monthly_contribution_type : false,
          showRental: this.productData.display_settings_show_vehicle_rental ? this.productData.display_settings_vehicle_rental_type : false,
        }
      }

      // not required
      return false;
    },

    productData() {
      return this.adminPortalData.content.products[this.route.params.scheme][0];
    },
  },

  methods: {
    // Slick
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      // console.debug('handleAfterChange', event, slick, currentSlide);
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      // console.debug('handleBeforeChange', event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
      // console.debug('handleBreakpoint', event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
      // console.debug('handleDestroy', event, slick);
    },
    handleEdge(event, slick, direction) {
      // console.debug('handleEdge', event, slick, direction);
    },
    handleInit(event, slick) {
      // console.debug('handleInit', event, slick);
    },
    handleReInit(event, slick) {
      // console.debug('handleReInit', event, slick);
    },
    handleSetPosition(event, slick) {
      // console.debug('handleSetPosition', event, slick);
    },
    handleSwipe(event, slick, direction) {
      // console.debug('handleSwipe', event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
      // console.debug('handleLazyLoaded', event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
      // console.debug('handleLazeLoadError', event, slick, image, imageSource);
    },

    hideStandardSpecification() {
      this.selectedVehicle = null;
    },

    paginatorUpdated(e) {
      this.$emit('paginationUpdated', e)
    },

    resetFilters() {
      EventBus.$emit('resetFilters', true);
    }
  },

  watch: {
    vehicles() {
      this.vehicles.forEach((vehicle) => {

        // Check if the derivative id of the vehicle is in the
        // quotes of the shortlist object
        this.shortListItems[vehicle.derivativeID] = [];

        let quote = collect(this.shortlist.quotes).where('derivativeID', vehicle.derivativeID).first();

        if (collect(this.shortlist.quotes).contains('derivativeID', vehicle.derivativeID)) {
          this.shortListItems[vehicle.derivativeID].push({quote: quote.quoteID, driverGradeId: quote.driverGradeID});
        }
      });
      if (this.shortListItemCount === null) {
        this.shortListItemCount = this.session.shortlists[this.scheme].validVehicleCount;
      }
      EventBus.$emit('shortlistUpdated', this.shortListItemCount);
    },
  },
}
</script>
